var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"fixed-bottom d-flex justify-content-center",attrs:{"id":"nav-menu"}},[_c('CButton',{class:_vm.view == 'home'
          ? 'nav-select navbar-brand pl-0 text-white text-center pr-0 nav-footer w-100 no-border-radius'
          : 'navbar-brand pl-0 text-black text-center pr-0 nav-footer w-100 border-end border-white border-3 border-dark no-border-radius',on:{"click":function($event){return _vm.mtdSelectView('home')}}},[_c('span',[_vm._v("COMANDAS DEL DIA")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }